import { Grid, Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AnnouncementsTab from "../../features/Search/components/AnnouncementsTab";
import ProfileActions from "../../features/Search/components/ProfileActions";
import ChatTabs from "../../features/Search/components/ChatTabs";
import { useDispatch, useSelector } from "react-redux";
import { setLayout } from "../../features/Auth/authSlice";
import SwipeEdge from "../../common/SwipeEdge";
import { ViewportSettings } from "../../pages";
import { toggleSwipe } from "../../features/Search/searchSlice";
import { Settings } from "@mui/icons-material";
import GnnTab from "../../features/Gnn/components/GnnTab";

function Left() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isLeftOpen = pathname.split("/").length < 3;
  const currentView = isLeftOpen ? "left" : "right";
  const handleNavClick = (nav) => {
    navigate(`${nav.path}`);
  };
  const handleAnnouncementClick = (nav) => {
    if (nav.path == "admin") {
      dispatch(setLayout("admin"));
      navigate("/admin");
      return;
    }
    navigate(`announcement/${nav.path}`);
  };

  const handleProfileClick = (empCode) => {
    // navigate(`aboutme/${empCode}`);
    console.log("ABOUTME");
  };
  const openConfig = () => {
    dispatch(toggleSwipe({ value: true }));
    window["ReactNativeWebView"] &&
      window["ReactNativeWebView"]?.postMessage(JSON.stringify({ type: "swipe", value: true }));
  };
  return (
    <Grid
      xs={12}
      lg={2.5}
      item
      sx={{
        borderRight: 0,
        borderColor: "divider",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        p: 1,
        pb: 0,
        gap: 1,
        // [theme.breakpoints.down("lg")]: {
        //   display: currentView === "left" ? "flex" : "none",
        //   flexDirection: "column",
        // },
      }}
    >
      {/* <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Logo />
        <IconButton
          onClick={() => handleNavClick({ path: 'home' })}
          style={{
            display: 'inline-block',
          }}
          disableRipple
        >
          <Code
            sx={{ fontSize: '2rem', background: '#0A4FAC', p: 1, color: 'white', borderRadius: '10px' }}
            style={{
              display: 'inline-block',
              color: !active ? '#004BAE' : 'white',
              backgroundColor: !active ? variants.boxBackground.PROFILE_CARD : '#004BAE',
            }}
          />
        </IconButton>
      </Box> */}

      {/* profile actions */}
      <ProfileActions handleNavClick={handleNavClick} handleProfileClick={handleProfileClick} />
      {/* profile list & team section */}

      {/* <ChatTabs /> */}
      <GnnTab />
      {/* announcements */}
      <AnnouncementsTab handleClick={handleAnnouncementClick} />
      {/* <IconButton
        onClick={() => openConfig()}
        sx={{
          display: "flex",
          position: "absolute",
          bottom: "calc(10vh)",
          left: "calc(2vw)",
          borderRadius: "50%",
          border: 1,
          borderColor: "divider",
          background: "white",
          cursor: "pointer",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 3px, rgba(0, 0, 0, 0.20) 0px 1px 3px",
          p: 1,
        }}
      >
        <Settings sx={{ color: "black" }} fontSize="small" />
      </IconButton> */}
      {currentView === "left" ? (
        <SwipeEdge
          height="70vh"
          drawerBleeding={0}
          title="Viewport"
          content={<ViewportSettings />}
          // sx={{ zIndex: "1300 !important" }}
          // sx={{ position: 'relative', zIndex: '1300 !important' }}
        />
      ) : null}
    </Grid>
  );
}

export default Left;
